
<!-- 
AgreedDeductionDetail.vue
功能：客戶權益-約定扣款獎勵活動 要保人目標保單件數視窗
作者：i94004v014 Hugo
完成：2023-09-19
-->
<template>
  <div id="send-result-modal" class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content" :class="{'section-loading': queryLoading}">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">要保人 {{apc_name | getMaskName}} 目標保單：</h3>
        </div>
        <div class="modal-body">
          <template>
            <div class="row">
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th id="th_serial" class="text-center">序號</th>
                    <th id="th_policy_no" class="text-center">保單號碼</th>
                    <th id="th_pay_style" class="text-center">繳費方式</th>
                    <th id="th_next_pay_day" class="text-center">下次應繳日</th>
                    <th id="th_apply_status" class="text-center">申辦情形</th>
                    <th id="th_note" class="text-center" width="190">備註</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in tableData" :key="`table-item-send-result-${i}`">
                    <td class="text-center">{{++i}}</td>
                    <td class="text-center">{{item.policy_no}}</td>
                    <td class="text-center">{{item.pay_way_code}}</td>
                    <td class="text-center">{{item.nxt_pay_date | dateFormat}}</td>
                    <td class="text-center">{{item.is_apply}}</td>
                    <td class="text-center"  width="190">{{item.label}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { commonMixin } from "@/mixins/common";
//service
import { getAgreedDeductionDetail } from "@/service";
export default {
  name: "AgreedDeductionDetail",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    apc_id: {
      type: String,
      default: ""
    },
    apc_name: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableData: [],
      queryLoading: false
    };
  },
  filters: {
  },
  watch: {
    open: function() {
      this.init();
    }
  },
  methods: {
    //初始化
    init() {
      this.tableData = [];
      this.sendLoading = false;
      this.queryLoading = true;
      getAgreedDeductionDetail(this.$store.state.userInfo.id, this.apc_id).then(
        result => {
          this.queryLoading = false;
          if (result.header && result.header.status === "200") {
            this.tableData = result.body.lists.map(item => {
              item.pay_way_code = this.getPayWayType(item.pay_way_code)
              item.is_apply = this.getApplyType(item.is_apply)
              return item;
            });

            this.tableData.sort(
                this.dateCompareFun(
                  true,
                  'nxt_pay_date',
                  null
                )
              );
          } else {
            this.setToastMsg("查詢失敗 : " + result.header.message);
          }
        }
      );
    },
    getPayWayType(pay_way_code){
      let resultType = ''
      switch(pay_way_code){
        case '3':
          resultType = '轉帳'
          break;
        case '4':
          resultType = '信用卡'
          break;
        case '6':
          resultType = '自繳'
          break;
        case '1':
          resultType = '人工件'
          break;
      }
      return resultType
    },
    getApplyType(is_apply){
      if(is_apply==='Y')
        return '已申辦'
      else
        return '未申辦'
    },
    sortCompareByFieldFun(isAsc, mainProperty, subProperty = null) {
      let sortOrder = 1;
      if (!isAsc) {
        sortOrder = -1;
      }
      return function (a, b) {
        let result =
          a[mainProperty] < b[mainProperty]
            ? -1
            : a[mainProperty] > b[mainProperty]
              ? 1
              : 0;
        if (result == 0 && subProperty != null) {
          result =
            a[subProperty] < b[subProperty]
              ? -1
              : a[subProperty] > b[subProperty]
                ? 1
                : 0;
        }
        return result * sortOrder;
      };
    },
    dateCompareFun(isAsc, mainProperty, subProperty = null) {
      let sortOrder = 1;
      if (!isAsc) {
        sortOrder = -1;
      }
      return function(a, b) {
        let date_a = new Date(
          a[mainProperty] ? a[mainProperty] : "1880-01-01"
        ).getTime();
        let date_b = new Date(
          b[mainProperty] ? b[mainProperty] : "1880-01-01"
        ).getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
  }
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}
</style>